import { iconNames } from '@zapier/design-system';
export const buttonConfig = {
    name: 'Button',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/d292335e4fb1ac5e6679363e894ee799.svg',
    noWrap: true,
    inputs: [
        {
            name: 'text',
            type: 'string',
            required: true,
        },
        {
            name: 'href',
            friendlyName: 'URL',
            type: 'string',
            required: true,
        },
        {
            name: 'openInNewTab',
            type: 'boolean',
        },
        {
            name: 'color',
            type: 'string',
            enum: ['primary', 'primary-alt', 'secondary', 'danger', 'tertiary'],
            defaultValue: 'primary',
        },
        {
            name: 'size',
            type: 'string',
            enum: ['xsmall', 'small', 'medium', 'large'],
            defaultValue: 'medium',
        },
        {
            name: 'iconBefore',
            friendlyName: 'Icon',
            type: 'string',
            enum: ['', ...Object.keys(iconNames)],
        },
        {
            name: 'isFullWidth',
            friendlyName: 'Full width',
            type: 'boolean',
        },
        {
            name: 'hasShadow',
            friendlyName: 'Shadow',
            type: 'boolean',
        },
    ],
};
//# sourceMappingURL=config.js.map